// monthlyParity.js (Service File)
// Phase 4 diagnostic tool: compares the Node engine's computed MONTHLY
// payroll against CI4's real pms_salary_slip, for validation only - not
// part of any live payroll workflow. Writes to pms_salary_slip_shadow.
import axiosInstance from "../Axios";

function getMonthlyParityList(pageNo = 1, params) {
  const queryParams = { pageNo };
  if (params && Object.keys(params).length > 0) Object.assign(queryParams, params);
  return axiosInstance.get("/payroll/monthly-parity", { params: queryParams });
}

function getMonthlyParityDetail(id) {
  return axiosInstance.get(`/payroll/monthly-parity/record/${id}`);
}

function runMonthlyParity(employeeId, date) {
  return axiosInstance.post(`/payroll/monthly-parity/${employeeId}`, null, { params: { date } });
}

export { getMonthlyParityList, getMonthlyParityDetail, runMonthlyParity };
